import React, {useCallback, useState} from 'react';

import {ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChatInput, useChatInputControls} from 'llm/chat-library/ChatInput';
import ChatScrollContainer from 'llm/chat-library/ChatScrollContainer';
import {LatestUserMessageInfo} from 'llm/ChatScrollTypes';
import {useActivityModalControls} from 'llm/deep-research/ActivityModal';
import {
  DeepResearchMessageThread,
  useDeepResearchMessageThread,
} from 'llm/deep-research/DeepResearchMessageThread';
export interface DeepResearchChatProps {
  chatId: string;
}

export function DeepResearchChat({chatId}: DeepResearchChatProps): JSX.Element {
  const {getFileUploads, ...controls} = useChatInputControls(ChatType.DEEP_RESEARCH);
  const {inputText, setInputText, agentMode, publicDataEnabled, setSelectedFiles} = controls;
  const {messages, progressData, isSubmitting, sendMessage, isLoading} = useDeepResearchMessageThread({
    chatId,
  });
  const {openActivityModal} = useActivityModalControls();
  const [latestUserMessageInfo, setLatestUserMessageInfo] = useState<LatestUserMessageInfo | null>(null);

  const handleSubmitMessage = useCallback(async () => {
    if (!inputText.trim() || isSubmitting || !agentMode) {
      return;
    }

    setInputText('');
    setSelectedFiles([]);
    await sendMessage(agentMode, inputText, {
      publicDataEnabled,
      fileUploads: getFileUploads(),
    });
  }, [
    inputText,
    isSubmitting,
    publicDataEnabled,
    sendMessage,
    getFileUploads,
    setInputText,
    setSelectedFiles,
    agentMode,
  ]);

  return (
    <ChatScrollContainer
      chatMessagesElement={
        <DeepResearchMessageThread
          chatSessionId={chatId}
          isLoading={isLoading}
          messages={messages}
          progressData={progressData}
          openActivityModal={openActivityModal}
          onUpdateLatestUserMessageInfo={setLatestUserMessageInfo}
        />
      }
      chatInputElement={
        <ChatInput
          chatSessionId={chatId}
          {...controls}
          onSubmit={handleSubmitMessage}
          inputDisabled={isSubmitting}
        />
      }
      latestUserMessageInfo={latestUserMessageInfo}
      autoScroll={true}
    />
  );
}
